import {AUTH_LOGIN_REQUESTED, AUTH_LOGIN_SUCCESS, AUTH_LOGIN_FAILURE, AUTH_LOGOUT, AUTH_USER_REQUESTED,
    AUTH_IMPERSONATE_REQUESTED, AUTH_IMPERSONATE_SUCCESS, AUTH_IMPERSONATE_FAILURE} from '../constants';

export const requestLogin = (username, password) => ({type: AUTH_LOGIN_REQUESTED, payload: {username, password}});
export const loginSuccess = (user) => ({type: AUTH_LOGIN_SUCCESS, payload: {user}});
export const loginFailure = (error) => ({type: AUTH_LOGIN_FAILURE, payload: {error}});
export const logout = () => ({type: AUTH_LOGOUT});
export const requestCurrentUser = () => ({type: AUTH_USER_REQUESTED});
export const requestImpesonate = (id) => ({type: AUTH_IMPERSONATE_REQUESTED, payload: {id}});
export const impersonateSuccess = (user) => ({type: AUTH_IMPERSONATE_SUCCESS, payload: {user}});
export const impersonateFailure = (error) => ({type: AUTH_IMPERSONATE_FAILURE, payload: {error}});
